import React, { useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import bg from "./img/auth-bg.jpg";
import StorageContext from "../../utils/contexts/StorageContext";
import ModalContext from "../../utils/contexts/ModalContext";
import TopNavBar from "../../components/TopNavBar";
import { VerifyEmailSuccessModal, VerifyEmailFailModal } from "../../components/Modal";
import { postWebVerifyEmailUserAPI } from "../../utils/visitorLogAxiosAPI";
import { encryptWithAES } from "../../utils/crypto"; 

const VerifyEmail = () => {

  const storageContext = useContext(StorageContext); 

  const search = useLocation().search;
  const emailQueryParam = new URLSearchParams(search).get("email");

  const [isResponseSuccess, setIsResponseSuccess] = useState(false);
  const [isVerifyEmailModalRequired, setIsVerifyEmailModalRequired] = useState(false);

  const { mutate, isLoading } = useMutation(postWebVerifyEmailUserAPI, {
    onSuccess: (data) => {
        // console.log("useMutation Success response data: ", data?.data);
        if (data?.data?.ok === true) { 
          setIsResponseSuccess(true); 
          setIsVerifyEmailModalRequired(true);
        }
    },
    onError: (error, variables) => {
        // console.log("useMutation Error response data: ", error?.response?.data);
        if (error?.response?.data?.ok === false) { 
          setIsResponseSuccess(false); 
          setIsVerifyEmailModalRequired(true);
        }
    },
  });

    const { register, handleSubmit, formState: { errors } } = useForm({ // getValues, watch, , setError, reset, setError, setValue , clearErrors
        mode: "onBlur", // mode: "all", "onBlur", "onChange", "onTouched"
        defaultValues: {
          email: "",
          password: "",
        },
    });

    const onValid = (submittedFormData) => {
      const { verifyEmailToken } = submittedFormData;

      if (!emailQueryParam || isLoading || !verifyEmailToken) return;

      const updateData = {
        email: emailQueryParam,
        verifyEmailToken
      };

      const encryptedUpdateData = encryptWithAES(updateData);
      if (!encryptedUpdateData) return;

      mutate({ data: encryptedUpdateData });

    };
    
    const onInvalid = (errors) => {
        console.log("onInvalid errors: ", errors);
        console.log("This is onInvalid!");
    };

    return (
      <div>
        <TopNavBar />
        <div className="flex w-screen h-screen justify-center items-center">
            <img src={bg} alt="auth-bg-03" className="fixed w-full h-full object-cover" />
            <div className="w-screen inset-0 max-w-sm lg:w-96 z-10 bg-gray-300 bg-opacity-70 p-10 rounded-xl">
                
                {/* <h2 className="text-center text-4xl font-thin tracking-tight text-gray-900">이메일 본인 인증</h2> */}
                
                <form 
                  onSubmit={handleSubmit(onValid, onInvalid)}
                  className="space-y-6"
                  spellCheck="false"
                >

                {/* (1). VERIFY EMAIL ADDRESS */}
                <div>
                  <label 
                      htmlFor="verifyEmailToken" 
                      className="block text-lg font-extralight text-gray-800"
                  >
                    {storageContext.localLanguage !== "english" ? "이메일 인증번호": "Email Authentication Number"}
                  </label>
                    <input
                        id="verifyEmailToken"
                        name="verifyEmailToken"
                        label="verifyEmailToken"
                        type="text"
                        placeholder="ex. 123456"

                        {...register("verifyEmailToken", {
                            required: storageContext.localLanguage !== "english" ? "이메일로 발송된 인증번호는 필수입니다.": "You authentification number sent by email is required.", // "이메일로 발송된 인증번호는 필수입니다.",
                            validate: {
                              // notContains4321: (value) => !value.includes("4321") || "Sorry, a valid resetPasswordToken should NOT contain '4321'.", // if return false -> validation error!
                              noWhiteSpace: (value) => value === value.trim() || (storageContext.localLanguage !== "english" ? "공백이 없어야 합니다." : "No whitespace is allowed."), // "띄어쓰기를 없애주세요!",
                              // positive: v => parseInt(v) > 0,
                              // lessThanTen: v => parseInt(v) < 10,
                            },
                        })}
                        className="text-gray-600 mt-2 block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-cyan-500 focus:outline-none focus:ring-cyan-500 sm:text-sm"
                    />
                    <p className="mt-2 text-md font-extralight text-red-600">{errors?.verifyEmailToken?.message}</p>
                </div>

                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md border border-transparent bg-cyan-500 py-2 px-4 text-lg font-light text-white shadow-sm hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2"
                >
                  {storageContext.localLanguage !== "english" ? "이메일 본인인증": "Verify Email"}
                </button>
              </form>
            </div>

          <ModalContext.Provider value={{ isVerifyEmailModalRequired, setIsVerifyEmailModalRequired }}>
            {(isResponseSuccess)
            ? <VerifyEmailSuccessModal message={storageContext.localLanguage !== "english" ? "이메일 본인 인증이 성공했습니다!" : "Email verification succeeded!"} moveToPage="/login" /> 

            : (!isResponseSuccess)
            ? <VerifyEmailFailModal message={storageContext.localLanguage !== "english" ? "이메일 본인 인증이 실패했습니다!" : "Email verification failed!"} />

            : null}

            {/* {isResponseSuccess && <VerifyEmailSuccessModal message="이메일 본인 인증이 성공했습니다!" moveToPage="/login" /> }
            {!isResponseSuccess && <VerifyEmailFailModal message="이메일 본인 인증이 실패했습니다!" /> } */}
          </ModalContext.Provider>
        </div>
      </div>
    )
};

export default VerifyEmail;
  